import React from 'react';
import logo from '../assets/icons/logo.png';

const Header = () => {
    return (
        <header>
            <div className='container'>
                <a className='logo' href='#main-content'>
                    <img src={logo} alt='Axiomatika'/>
                </a>
            </div>
        </header>
    );
};

export default Header;
